import { StatusError } from 'bent';

export const isErrorBentStatusError = (error: unknown): error is StatusError =>
  error instanceof Error && 'statusCode' in error;
